
import React from 'react';
import { Box, Card, Divider, TableBody, TextField } from '@mui/material';
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import Edit from "../../../../icons/edit.svg";
import Trash from "../../../../icons/trash1.svg";
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import { useState, useEffect } from 'react';
import { MenuItem } from "@mui/material";
import Select from "@mui/material/Select";
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import NotificationsSetupEditandAdd from './NotificationsSetupEditandAdd';
import axios from '../../../../utils/fvAxios';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import Nodata from "../../../Nodata/Nodata";
import { ToastContainer, toast } from 'react-toastify';
import Paginator from "../../../../toolkit/Paginator";
import { HasPermissions } from '../../../../utils/Token';
import INFO from '../../../../pages/commom/RouteUrlInfo.json';
import PER from "../../../../utils/Enums.json";


export default function NotificationsSetup() {

    const StyledTableCell = styled(TableCell)(({ theme }) => ({
        [`&.${tableCellClasses.head}`]: {
            backgroundColor: theme.palette.action.hover,

        },
        [`&.${tableCellClasses.body}`]: {
            fontSize: 14,
        },
        // hide last border
        '&:last-child td, &:last-child th': {
            border: 0,
            marginBottom: "20px"
        },
    }));
    const MenuProps = {
        PaperProps: {
            style: {
                maxHeight: 50 * 5 + 8,
                width: 200,
            },
        },
    };
    const theme = useTheme();
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [shows, setShow] = useState(true);
    // function setPage(pageNumber) {}

    const [spinner, setSpinner] = React.useState(false);
    const [open, setOpen] = useState(false);
    const [Tab, setTab] = useState("");
    const [id, setID] = useState("");
    const [Data, setData] = useState({});
    const [number, setNumber] = useState("1");
    const [Search, setSearch] = useState("");


    const OpenTab = (num, data) => {
        setTab(num);
        setOpen(true);
        setData(num == 2 ? data : "");
        setID(num == 3 ? data?.id : "");
    };
    const SpinnerClose = () => {
        setSpinner(false);
    };
    const CloseTab = () => {
        setOpen(false);
    };

    const FreeSearch = (e) => {
        setSearch(e);
    }
    const handlePageChange = (event) => {
        setNumber(event);
    };

    const [AdminNotifications, setAdminNotifications] = React.useState([]);
    const [AdminNotificationsCount, setAdminNotificationsCount] = useState("");
    const [Trg, setTrg] = React.useState(false);

    useEffect(() => {
        GetAdminNotifications();
    }, [Trg, Search, number]);

    async function GetAdminNotifications() {
        setSpinner(!spinner);
        const res = await axios.get("SystemUser/GetAdminNotifications?pageNumber=" + number + "&pageSize=" + 12 + "&filters=" + Search + "&Type=3");
        setAdminNotifications(res?.data?.data);
        setAdminNotificationsCount(res?.data?.count);
        setSpinner(spinner);
    }


    return (
        <>
            <ToastContainer />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={spinner}
                onClick={SpinnerClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
            <Dialog fullScreen={fullScreen} open={open} onClose={CloseTab}>
                <DialogContent sx={{ padding: "48px 48px" }}>
                    <DialogTitle
                        sx={{
                            textAlign: "center",
                            fontWeight: 500,
                            fontSize: 20,
                        }}
                    >
                        <span style={{ fontSize: "larger" }} >{Tab == 3 ? "Delete Notification " : Tab == 1 ? " Add Notifications   " : " Edit Notifications  "} </span>
                    </DialogTitle>

                    <DialogActions >
                        <NotificationsSetupEditandAdd ID={id} TAB={Tab} CLOSE={CloseTab} DATA={Data} TRG={Trg} SETTRG={setTrg} PageChange={handlePageChange} />
                    </DialogActions>

                </DialogContent>
            </Dialog>
            <Card>
                <div style={{ marginLeft: "10px", marginTop: "10px" }}>
                    <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                        <h3>Notifications Setup</h3>
                    </div>
                </div>
                <Divider sx={{ marginTop: 2, marginBottom: 2, backgroundColor: "#667085;", height: "2px" }} />

                <div style={{ marginLeft: "15px", marginBottom: "15px" }}>
                    <Stack spacing={2} direction="row">
                        <TextField
                            placeholder='Search'
                            sx={{
                                "& legend": { display: "none" },
                                "& fieldset": { top: 0 },
                                fontFamily: "Arial, FontAwesome"
                            }}
                            variant="outlined"
                            size="small"
                            value={Search}
                            onChange={(e) => FreeSearch(e.target.value)}
                        />
                        <div style={{ marginLeft: "Auto", padding: "10px" }}>
                            {HasPermissions(INFO?.NotificationsSetup?.actionName, PER?.ScreenPermissions?.Insert) &&
                                <Button variant="contained" sx={{ padding: "inherit" }} onClick={() => OpenTab(1)}>+ Add New</Button>
                            }
                        </div>
                    </Stack >

                </div>
                <Box sx={{ backgroundColor: '#f8f9fa' }}>

                    <TableContainer component={Paper} sx={{ borderBottom: 0 }}>
                        <Table aria-label="customized table">
                            {AdminNotificationsCount < 1 ? <div hidden={spinner}><Nodata /> </div> : <>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Client Name</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> User Email's</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Admin Users Email's</span></StyledTableCell>
                                        <StyledTableCell ><span style={{ color: "#667085", fontSize: "16px" }}> Notification Type</span></StyledTableCell>
                                        <StyledTableCell >&nbsp;</StyledTableCell>
                                        <StyledTableCell >&nbsp;</StyledTableCell>

                                    </TableRow>
                                </TableHead>
                                {AdminNotifications?.map((r) =>
                                    <TableBody key={1}>

                                        <TableRow key={1}>

                                            <StyledTableCell sx={{ width: "20%" }}>
                                                {r?.clientName}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "20%" }}>
                                                {r?.usersEmails}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "20%" }}>
                                                {r?.adminUsersEmails}
                                            </StyledTableCell>
                                            <StyledTableCell sx={{ width: "20%" }}>
                                                {r?.type == "3" ? "Scorecard" : "Failed Check-in"}
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "5%" }} >
                                                {HasPermissions(INFO?.NotificationsSetup?.actionName, PER?.ScreenPermissions?.Modify) &&
                                                    <IconButton aria-label="edit" onClick={() => OpenTab(2, r)}>
                                                        <img src={Edit} alt="editicon" />
                                                    </IconButton>
                                                }
                                            </StyledTableCell>

                                            <StyledTableCell sx={{ width: "5%" }}>
                                                {HasPermissions(INFO?.NotificationsSetup?.actionName, PER?.ScreenPermissions?.Delete) &&
                                                    <IconButton aria-label="delete" onClick={() => OpenTab(3, r)}>
                                                        <img src={Trash} alt="trashicon" />
                                                    </IconButton>
                                                }
                                            </StyledTableCell>

                                        </TableRow>

                                    </TableBody>
                                )}
                            </>}
                        </Table>

                    </TableContainer>
                </Box >

            </Card>
            <div hidden={AdminNotificationsCount < 1}>
                <Paginator
                    count={Math.ceil(AdminNotificationsCount / 12)}
                    page={Number(number)}
                    margin="18px 0px"
                    onChange={handlePageChange}
                />
            </div>

        </>
    )
}



